export const AUTH_SET_SSO_CONFIG = (state, { data: ssoConfig }) => ({ ...state, ssoConfig });
export const AUTH_GET_SSO_CONFIG_FAILED = (state) => ({ ...state, ssoConfig: null });
export const AUTH_SET_SSO_PAGE_NAVIGATED = (state, { navigatedToSsoPage }) => ({
  ...state,
  navigatedToSsoPage
});
